const fonts = [];
const icons = [];
const css = [];

export default {
  defaultCulture: 'nl',
  fonts: fonts,
  icons: icons,
  css: css
};
